// API timestamps without an explicit offset follow the existing UTC convention.
export function customerHistoryTimestamp(value) {
  if (!value) return NaN;
  const source = String(value).trim();
  return Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(source) ? source : `${source.replace(' ', 'T')}Z`);
}

export function visibleCustomerMessages(messages, cutoff) {
  return (messages || []).filter((item) => customerHistoryTimestamp(item.create_time) >= cutoff);
}
